// redux
import { connect } from "react-redux";

// actions
import { 
  // step 1
  selectRestaurant,
  // step 2 
  selectProductCategory, 
  // step 3
  fetchProducts,
  selectProduct,
} from "store/actions/specifications";

// selectors
import { userRestaurantsSelector } from "selectors/user";
import { stepDataSelector } from "selectors/specifications";

// steps
import { default as StepSelectRestaurant } from "./StepSelectRestaurant";
import { default as StepSelectProductCategory } from "./StepSelectProductCategory";
import { default as StepSelectItem } from "./StepSelectItem";

// step 1
export const SidebarStepSelectRestaurant = connect(
  (state) => ({
    ...stepDataSelector(state),
    restaurants: userRestaurantsSelector(state),
  }),
  { selectRestaurant },
)(StepSelectRestaurant);

// step 2
export const SidebarStepSelectProductCategory = connect(
  stepDataSelector,
  { selectProductCategory },
)(StepSelectProductCategory);

// step 3
export const SidebarStepSelectItem = connect(
  stepDataSelector,
  { fetchProducts, selectProduct },
)(StepSelectItem);

// unknown step
export { default as SidebarStepUnknown } from "./StepUnknown";
